import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useDeleteCohortMutation, useGetCohortQuery } from '@verantos-dev/data-access-cohorts';
import { DialogButton } from '@verantos-dev/shared-components';
import { STATUS_LABEL_MAPPING } from '@verantos-dev/shared-components';
import { CohortStatusLegacy } from '@verantos-dev/types-cohorts';

import { useCohortModalContext } from '../context/modalContext';

export const useDeleteCohortModal = () => {
  const { itemId, closeDialog } = useCohortModalContext();
  const { projectId } = useParams<{ projectId: string }>();
  const [deleteMutation, { isLoading, error }] = useDeleteCohortMutation();
  const { data, isLoading: loadingCohort } = useGetCohortQuery(
    { cohortId: itemId || '', projectId: projectId || '' },
    {
      skip: !itemId || !projectId,
    }
  );

  const [saveButtonColor, setSaveButtonColor] = useState<DialogButton['color']>('destructive');

  const disableDeleteStatus = useMemo(() => {
    if (data?.data?.latestStatus) {
      return {
        isDisabled:
          data?.data?.latestStatus === CohortStatusLegacy.FINAL ||
          data?.data?.latestStatus === CohortStatusLegacy.PROCESSING,
        status: STATUS_LABEL_MAPPING[data?.data?.latestStatus?.toLowerCase()],
      };
    }
    return { isDisabled: false, status: 'Unknown' };
  }, [data?.data]);

  const onSubmit = async () => {
    if (projectId && itemId) {
      await deleteMutation({ projectId: projectId, cohortId: itemId });
      setSaveButtonColor('primary');
    }
  };

  return {
    isDisableDeleteStatus: disableDeleteStatus.isDisabled,
    isSubmitting: isLoading,
    deleteCohortError: error,
    isInitialLoading: loadingCohort,
    saveButtonColor,
    isValidForSubmit: !disableDeleteStatus.isDisabled && !loadingCohort && !isLoading,
    cohort: data?.data,
    onClose: closeDialog,
    onSubmit,
  };
};
